import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faHomeAlt,
  faPlus,
  faChartLine,
  faCompass,
  faUser,
  faPlay,
  faPause,
  faVolumeOff,
  faVolumeUp,
  faVolumeMute,
  faSync,
  faComments,
  faComment,
  faStar,
  faTrashAlt,
  faRetweet,
  faHeart as faHeartO,
  faHeart,
  faShareAlt,
  faTimes,
  faCheck,
  faExclamationTriangle,
  faCircleNotch,
  faArrowsAlt,
  faTv,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faPencil,
  faLightbulb,
  faQuestion,
  faList,
  faUsers,
  faPlayCircle,
  faMobile,
  faExternalLink,
  faAtlas,
  faUserFriends,
  faPowerOff,
  faForward,
  faBackward,
  faCheckCircle,
  faUserPlus,
  faUserMinus
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faHomeAlt,
  faPlus,
  faChartLine,
  faCompass,
  faUser,
  faPlay,
  faPause,
  faVolumeOff,
  faVolumeUp,
  faVolumeMute,
  faSync,
  faComments,
  faComment,
  faStar,
  faTrashAlt,
  faRetweet,
  faHeartO,
  faHeart,
  faShareAlt,
  faTimes,
  faCheck,
  faExclamationTriangle,
  faCircleNotch,
  faArrowsAlt,
  faTv,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faPencil,
  faLightbulb,
  faQuestion,
  faList,
  faUsers,
  faPlayCircle,
  faMobile,
  faExternalLink,
  faAtlas,
  faUserFriends,
  faPowerOff,
  faForward,
  faBackward,
  faCheckCircle,
  faUserPlus,
  faUserMinus
);

import {
  faStar as faStarSolid
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faStarSolid
);

import {
  faTumblrSquare,
  faFacebookSquare,
  faTwitterSquare,
  faPinterestSquare,
  faTumblr,
  faTwitter,
  faReddit
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faTumblrSquare,
  faFacebookSquare,
  faTwitterSquare,
  faPinterestSquare,
  faTumblr,
  faTwitter,
  faReddit
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default FontAwesomeIcon;



// WEBPACK FOOTER //
// ./src/services/Icons.js